export default __webpack_public_path__ + "static/media/ic_notification_history.9b4f1787.svg";